<div class="customer-feedback-dialog">
  <div class="customer-feedback-dialog_title">
    <h1 class="{{ titleClass }}">{{ data.title }}</h1>
  </div>
  @if (data.message) {
    <p class="customer-feedback-dialog_message mat-body-medium">{{ data.message }}</p>
  }
  <div class="customer-feedback-dialog_form">
    <form [formGroup]="form" (ngSubmit)="sendCustomerMessage(form.value)" class="feedback_form">
      <mat-form-field appearance="outline" hideRequiredMarker="true" floatLabel="never"
        class="feedback_textarea" [class.has-message]="!!data.message">
        <textarea matInput class="mat-body-medium bddc-dark-blue bold" formControlName="customer_feedback"
        placeholder="What's on your mind?"></textarea>

        @if (data.additionalInfo) {
          <input type="hidden" formControlName="bug_report">
        }
        @if (data.subject) {
          <input type="hidden" formControlName="subject">
        }
      </mat-form-field>

      <div class="errors">
        @if (form.invalid && form.controls['customer_feedback'].value.trim() != '' && form.controls['customer_feedback'].value.trim().length >= 1500) {
          <mat-error>Must be less than 1500 characters.</mat-error>
        }
        @if (form.invalid && form.touched && form.controls['customer_feedback'].value.trim() == '') {
          <mat-error>Message cannot be empty.</mat-error>
        }
        @if (form.invalid && form.touched && form.controls['customer_feedback'].errors.htmlExists != null) {
          <mat-error>This input contains invalid characters.</mat-error>
        }
      </div>

      <div mat-dialog-actions>
        <button mat-raised-button color="primary" [disabled]="this.form.invalid">
          {{ data.confirmButton }}
        </button>

         <a mat-raised-button (click)="closeDialog()" class="cancel-button large">{{
      data.cancelButton
    }}</a>
      </div>
    </form>
  </div>
</div>
